import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { map } from 'rxjs/operators';
import { FamilyTreeAdapter } from 'src/app/models/domain/adapters';
import { FamilyTreeSetService, YPMFAMILYTREESRVFamilyTree } from 'src/generated-clients/familytree';

@Injectable({
  providedIn: 'root',
})
export class FamilyTreeDataService {
  public constructor(
    private readonly familyTreeService: FamilyTreeSetService,
    private readonly familyTreeAdapter: FamilyTreeAdapter
  ) {}

  public getFamilyTreesByDesignId(designId: string) {
    const designIdPropertyName: keyof YPMFAMILYTREESRVFamilyTree = 'designID';

    return this.familyTreeService.familyTreeSetGet(`${designIdPropertyName} eq '${designId}'`).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((familyTree) => this.familyTreeAdapter.adaptToDomain(familyTree));
      })
    );
  }
}
